import { AbstractModel } from '@/models/abstractModel';
import { ITurnoverEventStats, ITurnoverEventStatsApi } from '@/types/turnoverEventStats';

export class TurnoverEventStats extends AbstractModel implements ITurnoverEventStats {
    public balance: number;
    public betCount: number;
    public settledBetCount: number;
    public stakeSum: number;
    public unsettledBetCount: number;
    public userCount: number;

    constructor(data: ITurnoverEventStatsApi) {
        super();
        this.betCount = data.bet_count;
        this.settledBetCount = data.settled_bet_count;
        this.unsettledBetCount = data.unsettled_bet_count;
        this.stakeSum = data.stake_sum ?? 0;
        this.balance = data.balance;
        this.userCount = data.user_count;
    }
}
